//const token = window.localStorage.getItem('a_tkn') || ''


import { prodEnvironment } from "@/env/env";
import { RegisterForm } from '@/types/auth.types'
import { Geolocation } from '@capacitor/geolocation';


import { ref } from 'vue'
import { presentToast, tokenIsDead } from "./user.services";
import { infoDevice } from "./map.services";
import { Preferences } from "@capacitor/preferences";
import { useIonRouter } from "@ionic/vue";
import { Dialog } from "@capacitor/dialog";
import { resetSessionTimer } from "./session.services";



export const utilisateurPrenom = ref('')
export const utilisateurNom = ref('')
export const utilisateurNumero = ref('')
export const utilisateurAdresse = ref('')
export const utilisateurSociete = ref('')
export const utilisateurSiren = ref('')
export const utilisateurMail = ref('')
export const authorisedLocation = ref(false)
export const statusLocation = ref();

export const loginMessage = ref('')
export const roles = ref([''])

export const defineUser = async (userInformation: any) => {
    const parsed = JSON.parse(userInformation)
    utilisateurPrenom.value = parsed.firstname
    utilisateurNom.value = parsed.lastname
    utilisateurNumero.value = parsed.number
    utilisateurAdresse.value = ''
    utilisateurSociete.value = parsed.company
    utilisateurMail.value = parsed.email
    utilisateurSiren.value = parsed.siren
    authorisedLocation.value = parsed.authorisedLocation
    roles.value = parsed.roles

    if (infoDevice.platform == 'ios' || infoDevice.platform == 'android') {
        statusLocation.value = await Geolocation.checkPermissions();
        if (statusLocation.value.location == 'denied' || statusLocation.value.location == 'prompt') { //Verify is location is granted
            statusLocation.value = false; //If not, set statusLocation to false
            if (statusLocation.value.location == 'prompt' || statusLocation.value.location == 'granted') {
                //prompt user to allow location
                const { value } = await Dialog.confirm({
                    title: 'Localisation',
                    message: `Pour vous retrouver sur la carte, souhaitez-vous autoriser la localisation ?`,
                });
                if (value) {
                    statusLocation.value = await Geolocation.requestPermissions(); //Ask for permission
                    if (statusLocation.value.location == 'denied') { //If permission is denied
                        authorisedLocation.value = false; //Set authorisedLocation to false
                        presentToast(`La localisation n'est pas autorisée`, 'info'); //Display a toast to inform the user
                    } else if (statusLocation.value.location == 'granted') { //If permission is granted
                        authorisedLocation.value = true; //Set authorisedLocation to true
                        presentToast(`La localisation est actuellement autorisée`, 'info'); //Display a toast to inform the user
                    }
                } else {
                    authorisedLocation.value = false; //Set authorisedLocation to false
                    presentToast(`La localisation n'est pas autorisée`, 'info'); //Display a toast to inform the user
                }
            }
            else {
                authorisedLocation.value = false; //Set authorisedLocation to false
                presentToast(`La localisation n'est pas autorisée`, 'info'); //Display a toast to inform the user
            }

        }
        else if (statusLocation.value.location == 'granted') {
            authorisedLocation.value = true; //Set authorisedLocation to false
            presentToast(`La localisation est autorisée `, 'info'); //Display a toast to inform the user

        } else {
            authorisedLocation.value = false; //Set authorisedLocation to false
            presentToast(`La localisation n'est pas autorisée `, 'info'); //Display a toast to inform the user
        }
        //

        /*statusLocation.value = await Geolocation.requestPermissions(); //Ask for permission
        if (statusLocation.value.location == 'denied') { //If permission is denied
            authorisedLocation.value = false; //Set authorisedLocation to false
            presentToast("La localisation n'est pas autorisée", 'info'); //Display a toast to inform the user
        } else if (statusLocation.value.location == 'granted') { //If permission is granted
            authorisedLocation.value = true; //Set authorisedLocation to true
            presentToast("La localisation est actuellement autorisée", 'info'); //Display a toast to inform the user
        }*/
    } else {
        authorisedLocation.value = true; //Set authorisedLocation to false

        presentToast("La localisation est actuellement autorisée", 'info'); //Display a toast to inform the user
    }
}





export const verifyTokenService = async () => {
/*     //console.log('verify token service:');
 */    const response = await fetch(`${prodEnvironment.baseUrl}api/auth/check-token-state`, {
    method: 'GET',
    credentials: 'include',
    headers: {
        'Content-Type': 'application/json',
    }
})
    if (response.status === 200 || response.status === 201) return true;
    return false;
}

export const checkTokenStateService = async () => {

    const response = await fetch(`${prodEnvironment.baseUrl}api/auth/check-token-state`,
        {
            method: 'POST',
            credentials: 'include',
            headers: { 'Content-Type': 'application/json' }
        })
    if (response.status === 200) return true;
    return false;
}
export const isLastTokenService = async () => {
    //console.log("go")
    const response = await fetch(`${prodEnvironment.baseUrl}api/auth/checklasttoken`, {
        method: "POST",
        credentials: "include",
        headers: {
            'Content-Type': 'application/json',
        }
    })
    const data = await response.json();
    //console.log(response)
    //console.log(data)
    if (data.message == 'Token invalide') {
        tokenIsDead()
        return false;
    }
    if (response.status === 200) return true;
}
export const loginService = async (email: string, password: string, version: string) => {

    const response = await fetch(`${prodEnvironment.baseUrl}api/auth/login`, {
        method: "POST",
        credentials: "include",

        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({ email, password, version })
    });
    const data = response;

    return await data;
}

export const test = async () => {
/*     //console.log('wesh')
 */}
export const registerService = async (form: RegisterForm) => {
/*     //console.log(form);
 */    const response = await fetch(`${prodEnvironment.baseUrl}api/auth/register`, {
    method: "POST",
    credentials: "include",
    headers: {
        'Content-Type': 'application/json'
    },
    body: JSON.stringify(form)
})
    const data = await response.json();
/*     //console.log(data);
 */    return data;
}

export const editRegisteredUser = async (form: any) => {
    const response = await fetch(`${prodEnvironment.baseUrl}api/auth/edituser`, {
        method: "PATCH",
        credentials: "include",
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(form)
    })
    const data = await response.json();
    //console.log(data)
    if (response.status === 200) presentToast("Utilisateur modifié", 'info')
    if (data.message == 'Token invalide') tokenIsDead()
    return data;
}

export const registerNewUser = async (form: any) => {
/*     //console.log(form)
 */    const response = await fetch(`${prodEnvironment.baseUrl}api/auth/registeruser`, {
    method: "POST",
    credentials: "include",
    headers: {
        'Content-Type': 'application/json'
    },
    body: JSON.stringify(form)
})
    const data = await response.json();
    if (response.status === 200) presentToast("Utilisateur créé", 'info')
    if (data.message.includes('duplicate')) presentToast("Mail déjà utilisé", 'info')

    return data;
}

export const unRegisterUser = async (form: any) => {
    const response = await fetch(`${prodEnvironment.baseUrl}api/auth/unregisteruser`, {
        method: "DELETE",
        credentials: "include",
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(form)
    })

    const data = await response.json();
    if (response.status === 200) { presentToast("Utilisateur supprimé", 'info') }
    else (presentToast(data.message, 'info'))

    //console.log(data);
    return data;
}

export const logout = async () => {
    const router = useIonRouter();

    try {
        // Remplacez cette URL par l'URL de votre endpoint de déconnexion.
        const response = await fetch(`${prodEnvironment.baseUrl}api/auth/logout`, {
            method: "GET",
            credentials: "include",

            headers: {
                'Content-Type': 'application/json'
            },
        })

        if (response.status === 200) {
            // Déconnexion réussie.
            // Redirigez l'utilisateur vers la page de connexion (login).
            await resetSessionTimer();
            await Preferences.remove({ key: 'mesinformations' });
            router.push('/login');
            window.location.reload();

            // const toast = await toastController.create({
            //     message: `Déconnexion effectuée, redirection en cours, actualisez la page si la redirection ne s'est pas faite au bout de 10 secondes,`,
            //     duration: 10000,
            //     position: 'top',
            // });
            //await toast.present();

        } else {
            // Gérez les erreurs de déconnexion ici.
            console.error('Erreur lors de la déconnexion.');
        }
    } catch (error) {
        // Gérez les erreurs de requête ici.
        console.error('Erreur lors de la requête de déconnexion :', error);
    }
};
